import i18n from '@/lang';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { Message, MessageBox, Loading } from 'element-ui';

interface ResponseData {
  /** code
   * "0001","缺少参数"
   * "0002","无效参数"
   * "0003","无效签名"
   * "0004","验证失败"
   * "0005","服务不可用"
   * "0006","会话已失效" 会话已失效
   * "0007","没权限"
   * "1001","禁止访问"
   * "1002","请求错误"
   * "1003","请求成功"
   * "1004","服务器错误"
   * "1005","访问外部服务错误"
   * "1006","网关超时"
   * "1007","feign调用失败"
   */
  code: string;
  data: {};
  datas: [];
  success: boolean;
  message: string;
}
// 设置loading
let globalLoading: any;
// 接口数量
let _requestCount: number = 0;
// 不需要loading的接口
const notLoadUrl: any = [
  '/reminder-center/reminder/remindTask/getTaskCount',
  '/reminder-center/reminder/remindTaskQueue/getSystemMessage',
  '/permission-center/permission/staff/isLogin'
];
// 开始loading和配置
function startLoading(url?: any) {
  if (notLoadUrl.indexOf(url) === -1) {
    globalLoading = Loading.service({
      target: document.body,
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0)',
      customClass: 'apiLoadingStyle'
    })
  }
}
// 接口数量添加
const addRequestCount = ((url: any) => {
  if (notLoadUrl.indexOf(url) === -1) {
    _requestCount++;
  }
})
// 接口数量减少
const delRequestCount = ((url: any) => {
  if (notLoadUrl.indexOf(url) === -1) {
    _requestCount--;
  }
})
// 结束loading
function endLoading() {
  if (_requestCount <= 0) {
    globalLoading.close();
  }
}

const service: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 7*60*1000,
});

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    addRequestCount(config.url);
    startLoading(config.url);
    return config;
  },
  (error: AxiosError) => {
    startLoading()
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response: AxiosResponse<ResponseData>) => {
    const res: any = response.data;
    delRequestCount(response.config.url)
    if (response.status === 200&&res.code === '1003') {
      endLoading()
      return response;
    }else {
      Message.error({
        message: res.message ? res.message : i18n.t('common.errorCallAdmin') as string,
        dangerouslyUseHTMLString:true
      });
    }
    endLoading()
    return Promise.reject(res);
  },
  (error: AxiosError) => {
    delRequestCount(error.config.url)
    endLoading()
    Message.error({
      message: (error.response as any).data.message ? (error.response as any).data.message : i18n.t('common.errorCallAdmin') as string,
    });
    return Promise.reject(error);
  },
);

export const transformRequest = [(data: any) => {
  let ret = '';
  for (const it in data) {
    if (it) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    }
  }
  return ret;
}];

export default service;
